import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { HttpModule } from '@angular/http';
import { FormsModule } from "@angular/forms";
import { CabeceraModule } from "../../../../components/common/cabecera/cabecera.module";
import { DataTableModule } from "angular2-datatable";
import { Ng2Bs3ModalModule } from "ng2-bs3-modal/ng2-bs3-modal";
import { Ng2Webstorage } from "ngx-webstorage/dist/app";
import { Contragarantias } from "./contragarantias.component";

@NgModule({
    declarations: [Contragarantias],
    imports: [
        BrowserModule,
        HttpModule,
        FormsModule,
        CabeceraModule,        
        DataTableModule,
        Ng2Bs3ModalModule,      
        Ng2Webstorage],
    providers: [Contragarantias]
    
})

export class ContragarantiasModule { }


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/fianzas/contragarantias/contragarantias.module.ts